import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor() {
    this.applicationEventSubject = new BehaviorSubject<string>('');
    this.applicationEventSubscription = this.applicationEventSubject.asObservable();
  }

  applicationEventSubscription:Observable<string>;
  applicationEventSubject:BehaviorSubject<string>;
  isApplicationBusy:boolean = false;

  showGlobalSpinner():void {
    this.isApplicationBusy = true;
    this.applicationEventSubject.next('SHOWGLOBALSPINNER');
  }

  hideGlobalSpinner():void {
    this.isApplicationBusy = false;
    this.applicationEventSubject.next('HIDEGLOBALSPINNER');
  }
}